<template>
    <b-container fluid class="examenes-conductor card p-2">
        <div class="page-header mb-4 bg-dark">
            <h1 class="page-title">
                <i class="fa-solid fa-clipboard-check text-primary mr-3"></i>
                Información Complementaria
            </h1>
            <p class="page-subtitle">En este apartado se debe diligenciar la información que solicita la Super
                Transporte para registrar un despacho.</p>
        </div>

        <!-- Formulario de Alcoholimetría -->
        <formularioVehiculo @submit="registrarInfo" class="bg-dark rounded" />

        <formularioDespachoNovedad @submit="registrarInfo" class="bg-dark rounded" />

        <formularioDespachoRuta @submit="registrarInfo" class="bg-dark rounded" />

        <formularioDespachoConductor @submit="registrarInfo" class="bg-dark rounded" />



        <!-- Toast para notificaciones -->
        <b-toast id="success-toast" title="Éxito" variant="success" solid auto-hide-delay="5000">
            {{ successMessage }}
        </b-toast>

        <b-toast id="error-toast" title="Error" variant="danger" solid auto-hide-delay="5000">
            {{ errorMessage }}
        </b-toast>
    </b-container>
</template>

<script>
import formularioVehiculo from './formularioVehiculo.vue'
import formularioDespachoRuta from './formularioDespachoRuta.vue'
import formularioDespachoConductor from './formularioDespachoConductor.vue'
import formularioDespachoNovedad from './formularioDespachoNovedad.vue'

import Swal from 'sweetalert2'

export default {
    name: 'ExamenesConductor',
    components: {
        formularioVehiculo,
        formularioDespachoRuta,
        formularioDespachoConductor,
        formularioDespachoNovedad,
    },
    data() {
        return {
            tipoIdentificaciones: [],
            successMessage: '',
            errorMessage: '',
            usuario: {}
        }
    },
    props: {
        idDespacho: {
            required: true,
            default: null
        }
    },
    async mounted() {
        this.usuario = JSON.parse(localStorage.getItem('setPersonaAct') || '{}')
        await this.obtenerTiposIdentificacion()
    },
    methods: {
        async registrarInfo(data, endpoint) {
            try {
                let despacho = null

                if (endpoint == "CrearVehiculo") {
                    despacho = "idDespachos"
                }
                else if (endpoint == "CrearNovedad") {
                    despacho = "id_despacho"
                }
                else {
                    despacho = "idDespacho"
                }

                let dataFinal = { ...data, [despacho]: this.idDespacho }
                console.log("DATA FINAL", dataFinal);

                let response = await this.$store.dispatch('hl_post_cookie', {
                    path: `ApiSuperTransporteDespachos/${endpoint}`,
                    data: dataFinal
                })
                console.log("La respuesta es: ", response);
                this.mostrarAlerta(response)

            }

            catch (error) {
                this.mostrarAlerta(error)
                console.warn("Hubo un error al registrar el vehiculo", error);
            }
        },
        mostrarAlerta(response) {
            if (response.errores) {
                Swal.fire({
                    title: '¡Algo salio mal!',
                    text: `Error: ${response.mensaje}`,
                    icon: "warning"
                })
            }
            else {
                Swal.fire({
                    title: '¡Éxito!',
                    text: response.mensaje,
                    icon: "success"
                })
            }
        }
    }
}
</script>

<style scoped>
.examenes-conductor {
    min-height: 100vh;
    padding: 2rem 0;
}

.page-header {
    text-align: center;
    margin-bottom: 3rem;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 0 4px 6px rgba(75, 72, 72, 0.1);
}

.page-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.page-subtitle {
    font-size: 1.1rem;
    margin: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .page-title {
        font-size: 2rem;
    }

    .page-subtitle {
        font-size: 1rem;
    }

    .examenes-conductor {
        padding: 1rem 0;
    }
}
</style>
